<script lang="ts">
  import Icon from "@kontextwerk/web-sdk/ui/primitives/Icon.svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import { openHelpDialog } from "@kontextwerk/web-sdk/core/help/helpDialogs"
  import { mdiFileUploadOutline } from "@mdi/js"
  import { backlogListSourceNames } from "../../../../../../../../../../../../../../../../api/kehrblatt/backlog-lists"
  import type { ImportDraft } from "../../_shared/_logic/import-draft"

  const { draft }: { draft: ImportDraft } = $props()
  const data = $derived(draft.state)
  let fileInput = $state<HTMLInputElement>()
  const select = (files: FileList | null) => {
    if (files?.length === 1) void draft.selectFile(files[0])
    else if (files?.length) draft.rejectFiles()
  }
</script>

<div class="inspect-step">
    <div
    class="file-area"
    role="group"
    aria-label="Rückstandsliste hochladen"
    ondragover={(event) => event.preventDefault()}
    ondrop={(event) => {
      event.preventDefault()
      select(event.dataTransfer?.files ?? null)
    }}
  >
        <Icon path={mdiFileUploadOutline} />
        <strong>{data.file?.name ?? "CSV- oder PDF-Datei hier ablegen"}</strong>
        <CTA
      type="primaryButton"
      darkMode={false}
      content={data.file ? "Datei austauschen" : "Datei auswählen"}
      onClick={() => fileInput?.click()}
      disabled={data.submitting}
    />
        <input
      class="file-input"
      bind:this={fileInput}
      type="file"
      accept=".pdf,application/pdf,.csv,text/csv,application/csv,application/vnd.ms-excel"
      aria-label="Rückstandsliste auswählen"
      onchange={(event) => {
        select(event.currentTarget.files)
        event.currentTarget.value = ""
      }}
    />
    </div>
    <div aria-live="polite" role="status">
        {#if data.inspecting}
            <p style="color: var(--text-invers-100) !important;">Datei wird geprüft…</p>
        {:else if data.inspection}
            {#if data.inspection.source_system}
                <dl>
                    <dt>Erkanntes Format</dt>
                    <dd>{backlogListSourceNames[data.inspection.source_system]}</dd>
                </dl>
            {/if}
            {#if data.inspection.errors.length}
                <div class="file-errors" role="alert">
                    <strong>Bitte die Exportdatei korrigieren</strong>
                    {#each data.inspection.errors as issue, index (index)}
                        <p style="color: var(--text-invers-100) !important;">
                            <strong>{issue.message}</strong>{issue.columns.length
                ? ": " + issue.columns.join(", ")
                : ""}
                        </p>
                    {/each}
                </div>
            {:else}
                <p class="valid" style:color|important="var(--text-invers-100)">
                    Datei geprüft · {data.inspection.parsed_count} Einträge
                </p>
                {#if data.inspection.warnings.length}
                    <p style="color: var(--text-invers-100) !important;"
            >Einige Arbeitsangaben benötigen später eine Prüfung in der Planungstabelle.</p
          >
                {/if}
            {/if}
        {/if}
    </div>
    <CTA
    type="ghostButtonReverse"
    darkMode={false}
    content="Exporthilfe öffnen"
    onClick={() => openHelpDialog(data.inspection?.help_topic ?? "backlog-list-export")}
  />
</div>

<style>
  .inspect-step {
    display: grid;
    gap: 1rem;
    min-width: 0;
    padding: 0;
    color: var(--text-invers-100) !important;
  }
  .file-area {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 0;
    border-bottom: 1px dashed var(--text-invers-100);
    overflow-wrap: anywhere;
  }
  .file-area :global(svg) {
    width: 2rem;
    height: 2rem;
  }
  .file-input {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
  }
  dl {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin: 0;
  }
  dt {
    font-weight: 700;
  }
  dd {
    margin: 0;
  }
  p {
    margin: 0.5rem 0 0;
    color: var(--text-invers-100) !important;
    overflow-wrap: anywhere;
  }
  .file-errors {
    padding: 0.8rem;
    border-left: 3px solid var(--error-100);
  }
  .valid {
    font-weight: 700;
  }
  strong,
  dt,
  dd {
    color: var(--text-invers-100) !important;
  }
</style>
